"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDateNavigation = void 0;
var _react = require("react");
var _constants = require("../constants");
var _helpers = require("../helpers");
var useDateNavigation = (onDateChange, externalDate) => {
  var [startOffset, setStartOffset] = (0, _react.useState)(0);
  var [lastExternalDate, setLastExternalDate] = (0, _react.useState)(externalDate);
  (0, _react.useLayoutEffect)(() => {
    if (externalDate && externalDate !== lastExternalDate) {
      setLastExternalDate(externalDate);
      setStartOffset(0);
    }
  }, [externalDate, lastExternalDate]);
  var currentStartDate = (0, _react.useMemo)(() => {
    if (externalDate) {
      var _date = new Date(externalDate);
      _date.setDate(_date.getDate() + startOffset);
      return _date;
    }
    var date = new Date();
    date.setDate(date.getDate() + startOffset);
    return date;
  }, [startOffset, externalDate]);
  var {
    currentDates,
    arrival
  } = (0, _react.useMemo)(() => {
    var dates = (0, _helpers.generateDates)(currentStartDate, _constants.TABLE_CONFIG.DAYS_TO_SHOW);
    var arrivalString = currentStartDate.toISOString().split('T')[0];
    return {
      currentDates: dates,
      arrival: arrivalString
    };
  }, [currentStartDate]);
  var handleScrollLeft = (0, _react.useCallback)(() => {
    var newOffset = startOffset - _constants.TABLE_CONFIG.SCROLL_OFFSET;
    var baseDate = externalDate ? new Date(externalDate) : new Date();
    baseDate.setDate(baseDate.getDate() + newOffset);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var todayLocalString = "".concat(today.getFullYear(), "-").concat(String(today.getMonth() + 1).padStart(2, '0'), "-").concat(String(today.getDate()).padStart(2, '0'));
    var finalOffset = newOffset;
    var finalStartDate = baseDate;
    var baseDateString = "".concat(baseDate.getFullYear(), "-").concat(String(baseDate.getMonth() + 1).padStart(2, '0'), "-").concat(String(baseDate.getDate()).padStart(2, '0'));
    if (baseDateString < todayLocalString) {
      finalOffset = 0;
      finalStartDate = new Date(today);
    }
    setStartOffset(finalOffset);
    if (onDateChange) {
      var newDateString = "".concat(finalStartDate.getFullYear(), "-").concat(String(finalStartDate.getMonth() + 1).padStart(2, '0'), "-").concat(String(finalStartDate.getDate()).padStart(2, '0'));
      setLastExternalDate(newDateString);
      (0, _react.startTransition)(() => {
        onDateChange(newDateString);
      });
    }
  }, [startOffset, onDateChange, externalDate, setLastExternalDate]);
  var handleScrollRight = (0, _react.useCallback)(() => {
    var newOffset = startOffset + _constants.TABLE_CONFIG.SCROLL_OFFSET;
    var baseDate = externalDate ? new Date(externalDate) : new Date();
    baseDate.setDate(baseDate.getDate() + newOffset);
    var endDate = new Date(baseDate);
    endDate.setDate(endDate.getDate() + _constants.TABLE_CONFIG.DAYS_TO_SHOW - 1);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var maxAllowedDate = new Date(today);
    maxAllowedDate.setDate(maxAllowedDate.getDate() + 371);
    if (endDate > maxAllowedDate) {
      return;
    }
    setStartOffset(newOffset);
    if (onDateChange) {
      var newDateString = baseDate.toISOString().split('T')[0];
      setLastExternalDate(newDateString);
      (0, _react.startTransition)(() => {
        onDateChange(newDateString);
      });
    }
  }, [startOffset, onDateChange, externalDate, setLastExternalDate]);
  var isScrollLeftDisabled = (0, _react.useMemo)(() => {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var currentStartDateCopy = new Date(currentStartDate);
    currentStartDateCopy.setHours(0, 0, 0, 0);
    var currentEndDate = new Date(currentStartDateCopy);
    currentEndDate.setDate(currentEndDate.getDate() + _constants.TABLE_CONFIG.DAYS_TO_SHOW - 1);
    var todayInRange = today >= currentStartDateCopy && today <= currentEndDate;
    return todayInRange;
  }, [currentStartDate]);
  var isScrollRightDisabled = (0, _react.useMemo)(() => {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var maxAllowedDate = new Date(today);
    maxAllowedDate.setDate(maxAllowedDate.getDate() + 371);
    var currentStartDateCopy = new Date(currentStartDate);
    currentStartDateCopy.setHours(0, 0, 0, 0);
    var nextScrollStartDate = new Date(currentStartDateCopy);
    nextScrollStartDate.setDate(nextScrollStartDate.getDate() + _constants.TABLE_CONFIG.SCROLL_OFFSET);
    var nextScrollEndDate = new Date(nextScrollStartDate);
    nextScrollEndDate.setDate(nextScrollEndDate.getDate() + _constants.TABLE_CONFIG.DAYS_TO_SHOW - 1);
    return nextScrollEndDate > maxAllowedDate;
  }, [currentStartDate]);
  return {
    startOffset,
    currentStartDate,
    currentDates,
    arrival,
    handleScrollLeft,
    handleScrollRight,
    isScrollLeftDisabled,
    isScrollRightDisabled
  };
};
exports.useDateNavigation = useDateNavigation;